import { SearchItemType } from "@components/Store/StoreSearchInput/storeSearchInput.types";
import { getDamPath } from "@utils/configuration/aem";

export const ZOOM_INITIAL = 14.0;

export const STORE_DIRECTIONS_MESSAGE_ID = "store-directions-error";

export const HUBO_MARKER_URL = `${getDamPath()}/icons/maps/marker.png`;
export const HUBO_ICON_URL = `${getDamPath()}/icons/maps/icon.png`
export const DOT_MARKER_URL = `${getDamPath()}/icons/maps/marker-dot.svg`;

export const STORE_SEARCH_INPUT_TYPES = new Map<SearchItemType, number>([
    [SearchItemType.Locality, 5],
]);
